export async function waitForOffice(maxRetries = 5, delay = 1000): Promise<boolean> {
  for (let i = 0; i < maxRetries; i++) {
    if (typeof Office !== "undefined") {
      return true;
    }

    if (i < maxRetries - 1) {
      console.log(`Office.js not ready, retrying in ${delay}ms... (attempt ${i + 1}/${maxRetries})`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      delay *= 1.5;
    }
  }
  return false;
}
